import { Center, Image, Stack, Text } from "@mantine/core";
import React from "react";
import { loader } from "../images";


const MyLoader = () => {
    return (
        <Center h="100vh" w="100%">
            <Stack align="center" gap="sm">
                <Image src={loader} alt="Loading..." width={175} height={175}/>
                <Text size="lg" fw={500} c="grape">Loading, please wait...</Text>
            </Stack>
        </Center>
    );
};

export default MyLoader;
